<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="11.9999" r="9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M15 10L11 14L9 12" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>